import { baseApi } from "@dex/bubl-fetch";

const endpoint = 'LoadingTables';

const LoadingTablesApi: any = baseApi(endpoint);

export default LoadingTablesApi;